import { RouteConfig } from '@abaco/web-common/src/app';

const routes: RouteConfig[] = [
    {
        name: "precision-farming",
        path: "/precision",
        component: () => import("./components/PrecisionMapRecipeContainer.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}, "campaign-select-nav-bar-item"] }
    },
];

export default routes;
